module.exports = __webpack_public_path__ + "static/img/8.26e89e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/8.png
// module id = aJsM
// module chunks = 0